/** SUN-276: a vendor's saved address -> the PO "Vendor Billing Address" fields. */
export type PoAddress = { line1: string; line2: string; city: string; state: string; pincode: string; country: string };

export const emptyPoAddress = (): PoAddress => ({ line1: '', line2: '', city: '', state: '', pincode: '', country: 'India' });

const text = (v: unknown): string => (typeof v === 'string' ? v.trim() : typeof v === 'number' ? String(v) : '');

/**
 * Vendor.billingAddress is saved as {line1, city, state, pincode} (line2/country optional).
 * One free-text string goes whole into Line 1. Nothing is guessed from text; no address = empty fields.
 */
export function billingFromVendor(vendor: { billingAddress?: unknown } | null | undefined): PoAddress {
  const a = vendor?.billingAddress;
  const out = emptyPoAddress();
  if (typeof a === 'string') { out.line1 = a.trim(); return out; }
  if (!a || typeof a !== 'object' || Array.isArray(a)) return out;
  const o = a as Record<string, unknown>;
  out.line1 = text(o.line1); out.line2 = text(o.line2); out.city = text(o.city);
  out.state = text(o.state); out.pincode = text(o.pincode);
  out.country = text(o.country) || 'India';
  return out;
}
